import { toggleScrollLock } from 'common/utils';
import moment from 'moment';
import Cookie from 'js-cookie';

let ageGate = document.getElementById('age-gate');
let ageGateConfirmation = document.getElementById('age-gate-confirmation');
let oneMonth = moment.duration(1, 'months').asSeconds();

const scrollLockSelector = '#age-gate .Modal__content';

ageGate && toggleScrollLock(scrollLockSelector, true);

ageGateConfirmation &&
  ageGateConfirmation.addEventListener('click', () => {
    toggleScrollLock(scrollLockSelector, false);
    Cookie.set('hasVerifiedAgeGate', true, { expires: oneMonth });
    if (window.location.pathname.includes('locator')) {
      // TODO: Remove once full site launches. This prevents a user to be prompted twice with the age gate if they land on /locator
      Cookie.set('store', 'juul_us_en', { expires: oneMonth });
    }
    ageGate.remove();
  });



// WEBPACK FOOTER //
// ./app/javascript/apps/application/ageGate.js